<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMoreVertical_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        clip-rule="evenodd"
    />
</svg>
